const transparentColorButton = {
  title: "Transparent",
  // Inline `!important` beats the toolbar's `svg > path` stroke rules.
  svgIcon: `<svg width='18' height='18'>
      <path style='fill:currentColor !important;stroke:none !important' d='M9 4.513v10.642c-2.482 0-4.5-1.972-4.5-4.402 0-1.17.465-2.273 1.313-3.105L9 4.513ZM4.763 6.575A5.855 5.855 0 0 0 3 10.753c0 3.262 2.685 5.902 6 5.902s6-2.64 6-5.902a5.855 5.855 0 0 0-1.762-4.178L9 2.405l-4.237 4.17Z'/>
    </svg>`,
  query:
    ".ql-color-picker.ql-background .ql-picker-item[data-value='transparent']",
  style: [
    "width:100%",
    "height:26px",
    "border-radius: 4px",
    "padding:2px",
    "text-align:center",
    "display:flex",
    "align-items:center",
    "justify-content:center",
    "gap:8px",
    "font-size:14px",
  ],
};

export default transparentColorButton;
